import { IModalWindow } from '@hooks/useModalWindow';
import { IVendedor } from '@model/Vendedor';
import { IVendedorComissao, VendedorComissaoTipoEnum } from '@model/VendedorComissao';
import React from 'react';
import { ComissaoRegistrarModal } from './ComissaoRegistrarModal';

export type ComissaoCreditoModalProps = {
    modal: IModalWindow
    onComissaoRegistrada: (vendedorComissao: IVendedorComissao) => void
    vendedor: IVendedor
}

export function ComissaoCreditoModal ({ modal, vendedor, onComissaoRegistrada }: ComissaoCreditoModalProps) {
    return (
        <ComissaoRegistrarModal 
            modal={modal}
            vendedorComissaoTipo={VendedorComissaoTipoEnum.Credito}
            onComissaoRegistrada={onComissaoRegistrada}
            vendedor={vendedor}
        />
    )
}